import * as yup from 'yup';

export const firmasConformeSchema = yup.object().shape({
  // Firma cliente
  firmaClienteImagen: yup.string().required('Falta la firma del cliente'),
  // Firma técnico / mecánico
  firmaTecnicoImagen: yup.string().required('Falta la firma del técnico'),
});
